<template>
  <div v-loading="loading">

    <el-alert
        v-if="!tableData.length"
        :closable="false"
        class="noty-alert alert"
        title="Данные не найдены"
        type="warning"
    />

    <el-radio-group v-model="activeTab" class="ellipse-radio">
      <el-radio-button v-for="(item, index) of tableData" :key="index" :label="index">{{ item.title }}</el-radio-button>
    </el-radio-group>

    <el-collapse v-if="tableData.length" v-model="activeCollapse" accordion class="collapse-images-data">
      <el-collapse-item v-for="(item, index) of tableData[activeTab].items" :key="index" :name="index">
        <template slot="title">
          <div class="header">
            <div @click.stop="openPhoto(item.date.images)" class="header__title"><i class="el-icon-picture-outline"></i>
              Снимки ({{ item.date.images | length }})
            </div>
            <div class="header__date">{{ $root.dateDefault(item.date) }}</div>
          </div>
        </template>
        <div>{{ item.comment }}</div>
      </el-collapse-item>
    </el-collapse>

    <el-dialog
        title="Просмотр фото"
        :visible.sync="dialogShowPhoto"
        width="70%"
        class="dialog-show-photo"
    >
      <img
          v-for="(img, index) of selectPhoto"
          :key="index" :src="getUrlPhoto(img)"
          :alt="getUrlPhoto(img)"
          class="dialog-show-photo__img">
      <el-alert
          v-if="!selectPhoto"
          :closable="false"
          class="noty-alert"
          title="Изображения не найдены"
          type="warning"
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogShowPhoto = false">Закрыть</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "Tables",
  data() {
    return {
      loading: false,
      activeCollapse: '1',
      activeTab: 0,
      tableData: [],
      dialogShowPhoto: false,
      selectPhoto: [],

    }
  },
  computed: {
    ...mapGetters("visit", {
      visit: "data",
    }),
  },
  created() {
    this.loadLogic()
  },
  filters: {
    length(value) {
      return value ? value.length : 0
    }
  },
  watch: {},
  methods: {
    openPhoto(file) {
      this.dialogShowPhoto = true
      this.selectPhoto = file
    },
    getUrlPhoto(file) {
      return this.$root.getUrlPhoto(file)
    },
    loadLogic() {

      let params = {
        userId: this.visit?.user?.id,
      }
      console.log('params', params)
      this.loading = true

      this.$api.dynamics.getDiagnosticTable({params}).then((response) => {
        console.log(response.data)

        this.tableData = response.data
      })
          .catch(() => {
            this.options = []
          })
          .finally(() => {
            this.loading = false
          })
    },

  }

}

</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  margin-right: 22px;

  display: flex;
  align-items: center;
  justify-content: space-between;


  &__title {
    color: #43D3B3;
  }

  &__date {
    color: #676767;
  }

}

.ellipse-radio {
  margin: 17px 0;
}

.collapse-images-data {
  border-top: 0;

  /deep/ .el-collapse-item {
    margin-bottom: 0;
  }
}
.alert {
  margin-top: 30px;
}
</style>